import React from 'react'
import { useNavigate } from 'react-router-dom'
import '../Styles/Initial.css'
import Exit from '../Components/Exit'

function Initial() {
    const navigate = useNavigate()

  return (
    <section id='initial' className='flex-center flex-column flex__gap-100 full-window'>
        <div className='text-center flex-center flex-column flex__gap-20 half-screen'>
            <h1 className='title-main'>Sua Conexão com o <span>Grupo Fixx</span></h1>
            <p className='paragraph-default'>Somos um grupo formado por diversas empresas, cada uma com a missão de transformar e impulsionar o mercado em que atua. Conheça mais sobre cada uma de nossas empresas ou cadastre-se para ter acesso a uma experiência exclusiva com nossos serviços.</p>
        </div>
        <div className='flex-center flex__gap-20'>
            <button className='btn-default' onClick={() => navigate('/formulario')}>Cadastrar cliente</button>
            <button className='btn-default' onClick={() => navigate('/apresentacao')}>Ir para apresentação</button>
        </div>
        <div id='exit-bottom'>
            <Exit/>
        </div>
    </section>
  )
}

export default Initial
